import { Device, from } from '@helpers/media';
import { link, paragraphSmall } from '@helpers/typography';
import SocialLinksStyles from '@stories/Components/Misc/SocialLinks/SocialLinks.styles';
import styled from 'styled-components';
const NavigationContactInfo = styled.div `
  @media ${from(Device.DesktopSmall)} {
    margin-top: auto;
  }

  ${SocialLinksStyles.Container} {
    margin-top: 24px;
  }
`;
const NavigationContact = styled.p `
  ${paragraphSmall};

  margin-bottom: 12px;

  strong {
    font-weight: 800;
  }

  a {
    ${link};

    --textDecorationColour: currentColor;
  }
`;
const NavigationContactBlockStyles = {
    NavigationContactInfo,
    NavigationContact,
};
export default NavigationContactBlockStyles;
